<template>
    <v-dialog v-model="modal" :scrim="false" width="500">
        <v-card>
            <v-icon class="v-card-close" @click="modal = false">mdi-close</v-icon>
            <v-card-title class="text-h6 font-weight-light">{{ $t('the_ticket_will_be_voided') }}</v-card-title>
            <v-card-text>
                <v-radio-group v-model="voidingType">
                    <v-radio :label="$t('void_ticket')" value="void" />
                    <v-radio :label="`${$t('void_ticket_and_cancel_pnr')}`" value="void_and_cancel" />
                </v-radio-group>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn
                    :loading="isLoading"
                    :disabled="!voidingType"
                    color="primary"
                    variant="flat"
                    size="small"
                    @click="voidTicket"
                >
                    {{ $t('supplier.confirm') }}
                </v-btn>
                <v-btn color="grey" size="small" variant="flat" class="text-white" @click="modal = false">
                    {{ $t('close') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_TICKET_VOIDING_MODAL, CHANGE_LOCALE_EVENT} from '@/utils/event-bus'
    import {appInstance} from '@/utils/app-accessor'

    @Component
    export class TicketVoidingModal extends Vue {
        modal = false
        processId = null
        voidingType = ''
        isLoading = false

        mounted() {
            EventBus.$on(SHOW_TICKET_VOIDING_MODAL, this.showModal)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_TICKET_VOIDING_MODAL, this.showModal)
        }

        async showModal({processId}) {
            this.processId = processId
            this.modal = true
        }

        async voidTicket() {
            this.isLoading = true
            try {
                const voidRs = await appInstance.$api.voidFlightTicket.put({processId: this.processId})

                if (voidRs.status === 'PreConfirmed' && this.voidingType === 'void_and_cancel')
                    await appInstance.$api.cancelService.post({processId: this.processId})

                EventBus.$emit(CHANGE_LOCALE_EVENT)
                // eslint-disable-next-line no-empty
            } catch (e) {}

            this.isLoading = false
        }
    }

    export default TicketVoidingModal
</script>
